import { titleStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsTitle";
import { css } from "styled-components";

titleStyles.titleText = {
    variant: "h2",
    as: "h1",
    css: css`
        margin: .5rem 0 1.5rem 0;
    `,
};
